import React, { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ACTIVE_DIV } from "../../config/cacheKey";
import { GetCartablesResponse } from "../../models/cartable.model";
import { setstateCartable } from "../../redux/activeState/activeStateAction";
import { GetCartables } from "../../services/cartable.service";
import TableSupplierRequirmentCmp from "./TableSupplierRequirmentCmp";
import FilesStatus from "./filesStatus";
export default function SupplierRequirmentsPage() {
  const queryClient = useQueryClient();
  const [activeState, setActiveState] = useState<any>(
    queryClient.getQueryData(ACTIVE_DIV)
  );
  const dispatch = useDispatch();

  let history = useHistory<{ refetchStatus: boolean }>();
  useEffect(() => {
    if (
      history.location.state != undefined &&
      history.location.state.refetchStatus == true
    ) {
      refetch();
      queryClient.setQueryData(ACTIVE_DIV, 0);
      setActiveState(0);
      history.replace({ state: { refetchStatus: false } });
    }
  }, [history.location.state]);
  useEffect(() => {
    setActiveState(queryClient.getQueryData(ACTIVE_DIV));
  });

  let { data: cartableData, isLoading, refetch } = useQuery<
    GetCartablesResponse[]
  >(
    ["SupplierRequirements"],

    (): Promise<GetCartablesResponse[]> => {
      //todo
      return GetCartables({
        workflowType: "SupplierRequirements",
      });
    }
  );

  if (isLoading) {
    return <></>;
  } else {
    if (cartableData != null) {
      if (cartableData.length > 0) {
        // cartableData[0].status = "success";
        // dispatch(setstateCartable({ stateCartable: cartableData[0].state }));
        cartableData[activeState ? activeState : 0].status = "success";
        dispatch(
          setstateCartable({
            stateCartable: cartableData[activeState ? activeState : 0].state,
          })
        );

        return (
          <div>
            {/* <ToolsCmp />
            <br /> */}
            <FilesStatus
              workFlowType="SupplierRequirements"
              cartableData={cartableData}
              title={"وضعیت پذیرنده ها"}
            />
            <TableSupplierRequirmentCmp />
          </div>
        );
      }
      return (
        <div>
          <img
            className="classCenter"
            style={{ width: "30%", margin: "auto", marginTop: "5vh" }}
            src="images/empthuCartable.png"
            alt=""
          />
        </div>
      );
    }
  }
  //test
}
